"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runtimeALv1 = exports.ClientRuntimeALv1 = exports.getTypeFromSchema = exports.Workflow = void 0;
var alv1_interfaces_1 = require("@augloop/alv1-interfaces");
var logging_1 = require("@augloop/logging/dist/src/client/logging");
var runtime_client_1 = require("@augloop/runtime-client");
var alv1_schemas_1 = require("@augloop/schemas/dist/src/client/alv1-schemas");
var schemas_1 = require("@augloop/schemas/dist/src/client/schemas");
var reduce_timer_cache_1 = require("./reduce-timer-cache");
var RemoteLambdaHttp = require("./remote-lambda-http");
var RemoteLambdaWs = require("./remote-lambda-ws");
var result_cache_1 = require("./result-cache");
var runtime_types_1 = require("./runtime-types");
var throttling_1 = require("./throttling");
var WorkflowState;
(function (WorkflowState) {
    WorkflowState[WorkflowState["Restricted"] = 0] = "Restricted";
    WorkflowState[WorkflowState["Unrestricted"] = 1] = "Unrestricted";
    WorkflowState[WorkflowState["Suppressed"] = 2] = "Suppressed"; // Workflow will never run again (in this doc for this session)
})(WorkflowState || (WorkflowState = {}));
var Workflow = /** @class */ (function () {
    function Workflow() {
        this.canaryTextTileEventSubmittedByDocSessionId = new Set();
        this.stateByDocSessionId = new Map();
        this.executionQueueByDocSessionId = new Map();
        this.executionCountByDocSessionId = new Map();
    }
    Workflow.prototype.getOutputSchema = function () {
        return this.lambdas[this.lambdas.length - 1].outputSchema;
    };
    Workflow.prototype.scheduleExecution = function (input, execute) {
        var docSessionId;
        if (Workflow.trackingByDocSessionIdEnabled) {
            docSessionId = this.docSessionIdExtractor ? this.docSessionIdExtractor(input) : undefined;
        }
        else {
            docSessionId = this.docIdExtractor ? this.docIdExtractor(input) : undefined;
        }
        var state = this.getStateForDocSessionId(docSessionId);
        if (state === WorkflowState.Restricted) {
            var queue = this.getExecutionQueueForDocSessionId(docSessionId);
            queue.push(execute);
            if (queue.length === 1) {
                execute();
            }
        }
        else if (state === WorkflowState.Unrestricted) {
            execute();
        }
        else if (state === WorkflowState.Suppressed) {
            // Do nothing
        }
    };
    Workflow.prototype.onStart = function (docSessionId) {
        this.incrementExecutionCountForDocSessionId(docSessionId);
    };
    Workflow.prototype.onFinish = function (docSessionId, exceptionType) {
        this.decrementExecutionCountForDocSessionId(docSessionId);
        if (exceptionType === schemas_1.ExceptionType.Authentication) {
            // Suppress workflow if no token or invalid token obtained
            this.stateByDocSessionId.set(docSessionId, WorkflowState.Suppressed);
            this.executionQueueByDocSessionId.delete(docSessionId);
        }
        else if (this.stateByDocSessionId.get(docSessionId) === WorkflowState.Restricted) {
            var queue = this.getExecutionQueueForDocSessionId(docSessionId);
            queue.shift();
            if (exceptionType === undefined) {
                // We've had the first successful execution, subsequent
                // executions are now unrestricted and can run in parallel
                this.stateByDocSessionId.set(docSessionId, WorkflowState.Unrestricted);
                this.executionQueueByDocSessionId.delete(docSessionId);
                for (var _i = 0, queue_1 = queue; _i < queue_1.length; _i++) {
                    var callback = queue_1[_i];
                    callback();
                }
            }
            else if (queue.length > 0) {
                // Keep going one at a time
                var nextCallback = queue[0];
                nextCallback();
            }
        }
    };
    Workflow.prototype.onRefresh = function (docSessionId) {
        // Reset our state map (equivalent to going back to Restricted for all docs)
        // since the auth state may have changed as part of refresh
        this.stateByDocSessionId = new Map();
        if (this.triggerOnRefresh) {
            // Clear the execution queue(s) since all tiles will be resubmitted as part of the refresh
            if (docSessionId) {
                this.executionQueueByDocSessionId.delete(docSessionId);
                this.executionCountByDocSessionId.delete(docSessionId);
            }
            else {
                this.executionQueueByDocSessionId = new Map();
                this.executionCountByDocSessionId = new Map();
            }
        }
        // If using canary, we'll want to submit it again on refresh
        this.canaryTextTileEventSubmittedByDocSessionId.delete(docSessionId);
    };
    Workflow.prototype.getStateForDocSessionId = function (docSessionId) {
        var state = this.stateByDocSessionId.get(docSessionId);
        if (state === undefined) {
            state = Workflow.executionQueuesEnabled ? WorkflowState.Restricted : WorkflowState.Unrestricted;
            this.stateByDocSessionId.set(docSessionId, state);
        }
        return state;
    };
    Workflow.prototype.getExecutionQueueForDocSessionId = function (docSessionId) {
        var queue = this.executionQueueByDocSessionId.get(docSessionId);
        if (queue === undefined) {
            queue = [];
            this.executionQueueByDocSessionId.set(docSessionId, queue);
        }
        return queue;
    };
    Workflow.prototype.incrementExecutionCountForDocSessionId = function (docSessionId) {
        var count = this.executionCountByDocSessionId.get(docSessionId) || 0;
        this.executionCountByDocSessionId.set(docSessionId, count + 1);
    };
    Workflow.prototype.decrementExecutionCountForDocSessionId = function (docSessionId) {
        var count = this.executionCountByDocSessionId.get(docSessionId) || 0;
        if (count <= 1) {
            this.executionCountByDocSessionId.delete(docSessionId);
        }
        else {
            this.executionCountByDocSessionId.set(docSessionId, count - 1);
        }
    };
    Workflow.executionQueuesEnabled = true;
    Workflow.trackingByDocSessionIdEnabled = true;
    return Workflow;
}());
exports.Workflow = Workflow;
var getTypeFromSchema = function (schema) {
    return {
        category: schemas_1.TypeCategory.Schema,
        schema: {
            name: schema
        }
    };
};
exports.getTypeFromSchema = getTypeFromSchema;
var textTileSchema = 'Tiling.TextTileEvent';
var slideTileSchema = 'ClpSlideTile';
var isTileDeletedEvent = function (inputSchema, input) {
    return ((inputSchema === textTileSchema && input && input.type == alv1_schemas_1.Tiling.TextTileEventType.Delete) || (inputSchema === slideTileSchema && input && input.eventType == alv1_schemas_1.Ppt.SlideTileEventType.Delete));
};
var isTextTileRefreshEvent = function (inputSchema, input) {
    return inputSchema === textTileSchema && input && input.type == alv1_schemas_1.Tiling.TextTileEventType.Refresh;
};
var isSlideTileRefreshEvent = function (inputSchema, input) {
    return inputSchema === slideTileSchema && input && input.eventType == alv1_schemas_1.Ppt.SlideTileEventType.Refresh;
};
var isTileRefreshEvent = function (inputSchema, input) {
    return isTextTileRefreshEvent(inputSchema, input) || isSlideTileRefreshEvent(inputSchema, input);
};
var getTileRefreshSeq = function (inputSchema, input) {
    var _a, _b;
    if (isTextTileRefreshEvent(inputSchema, input)) {
        return (_b = (_a = input.tile) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.seqnoCLPRefresh;
    }
    if (isSlideTileRefreshEvent(inputSchema, input)) {
        return -1; // NYI
    }
    return -1;
};
var getTileDocSessionId = function (inputSchema, input) {
    var _a, _b;
    if (inputSchema === textTileSchema) {
        return (_b = (_a = input.tile) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.docSessionId;
    }
    if (inputSchema === slideTileSchema) {
        return input.docId; // Populated by PPT like a docSessionId (has a new value when re-opening the same doc)
    }
    return undefined;
};
var createCanaryTextTileEvent = function (template) {
    return {
        type: template.type,
        tile: {
            metadata: {
                docSessionId: template.tile.metadata.docSessionId,
                docId: template.tile.metadata.docId,
                seqnoCLPRefresh: template.tile.metadata.seqnoCLPRefresh,
                tileId: 'A56B3127DBDFD0D6'
            },
            elements: [{
                    text: 'B91153AE828B4E48'
                }]
        }
    };
};
var ClientRuntimeALv1 = /** @class */ (function () {
    function ClientRuntimeALv1() {
        this.inputSchemasToWorkflows = new Map();
        this.inputSchemasToReduceWorkflows = new Map();
        this.reduceWorkflowsGroupingKeyExtractors = new Map();
        this.defaultWorkflowOptions = { canProduceNullResult: false, shouldSendResultsToHost: true, enabledByDefault: false, throttleSettings: { shouldBeThrottled: false }, triggerOnRefresh: false };
        this.resultCache = new result_cache_1.ResultCache();
        this.reduceTimerCache = new reduce_timer_cache_1.ReduceTimerCache();
        this.lookupTableCache = new Map();
        this.throttling = new throttling_1.ExecutionWithThrottling();
        this.lastTileRefreshSeq = -1;
        this.lastTileRefreshSeqByDocSessionId = new Map();
        this.tileRefreshByDocSessionIdEnabled = true; // ChangeGate, can be removed once sufficiently baked
    }
    ClientRuntimeALv1.prototype.init = function (serviceUrl, clientMetadata, hostCallbacks) {
        var _this = this;
        var op = new logging_1.Operation({
            operationName: 'InitRuntimeALv1',
            resourceId: serviceUrl
        });
        op.start();
        this.clientMetadata = clientMetadata;
        if (this.clientMetadata) {
            this.clientMetadata.runtimeVersion = runtime_client_1.getVersion();
        }
        this.hostCallbacks = hostCallbacks;
        var promises = [];
        promises.push(this.isFeatureEnabled('DisableWebSocket')
            .then(function (isWebSocketDisabled) {
            // The isFeatureEnabled check above functions effectively as a ChangeGate, so invert the
            // rest of our logic to use what would have been the return value of a ChangeGate call.
            // NOTE: unit tests and automation still rely on DisableWebSocket; do not remove this
            // until that dependency no longer exists.
            var isWebSocketEnabled = !isWebSocketDisabled;
            if (!isWebSocketEnabled) {
                return false;
            }
            var appsUsingALv1 = [
                'Outlook Mac',
                'Outlook Win32',
                'PowerPoint Mac',
                'PowerPoint Web',
                'PowerPoint Win32',
                'Word Mac',
                'Word Win32'
            ];
            if (appsUsingALv1.indexOf(clientMetadata.appName + " " + clientMetadata.appPlatform) >= 0) {
                // Real-world network infrastructure sometimes doesn't support WebSocket even if the client does, so before
                // we commit to using WebSocket for ALv1 for this session, ensure that we can establish a healthy connection first.
                return RemoteLambdaWs.testWebSocketConnection(runtime_client_1.Utils.convertServiceUrlToWebSocket(serviceUrl), _this.clientMetadata);
            }
            else {
                // We can skip the connection test if the app won't be using ALv1.
                // TODO: we also need to support an HTTP fallback for ALv2 sessions, but that will be implemented at the session
                // level, not here; see User Story 3240069: HTTPS fallback when WebSocket isn't supported
                return true;
            }
        })
            .then(function (isWebSocketEnabled) {
            if (serviceUrl) {
                _this.serviceUrl = isWebSocketEnabled ? runtime_client_1.Utils.convertServiceUrlToWebSocket(serviceUrl) : serviceUrl;
                _this.executeRemoteLambda = isWebSocketEnabled ? RemoteLambdaWs.executeRemoteLambda : RemoteLambdaHttp.executeRemoteLambda;
                _this.clearRemoteLambdaTokenCache = isWebSocketEnabled ? RemoteLambdaWs.clearTokenCache : RemoteLambdaHttp.clearTokenCache;
                _this.serviceProtocol = _this.serviceUrl.split(':')[0].toLowerCase();
            }
        }));
        promises.push(this.isFeatureEnabled('WorkflowQueuesDisabled').then(function (isDisabled) {
            Workflow.executionQueuesEnabled = !isDisabled;
        }));
        promises.push(this.isFeatureEnabled('WorkflowTrackingByDocSessionIdDisabled').then(function (isDisabled) {
            Workflow.trackingByDocSessionIdEnabled = !isDisabled;
        }));
        promises.push(this.isFeatureEnabled('TileRefreshByDocSessionIdDisabled').then(function (isDisabled) {
            _this.tileRefreshByDocSessionIdEnabled = !isDisabled;
        }));
        return Promise.all(promises)
            .then(function () {
            _this.logOperation(op, true);
        })
            .catch(function (error) {
            _this.logOperation(op, false, 'Error', error ? error.message : '(no error)');
        });
    };
    ClientRuntimeALv1.prototype.getServiceProtocol = function () {
        return this.serviceProtocol;
    };
    ClientRuntimeALv1.prototype.registerSchemas = function (_unused1, _unused2) {
        return Promise.resolve();
    };
    ClientRuntimeALv1.prototype.registerSimpleLocalWorkflow = function (name, lambda, options) {
        if (options === void 0) { options = this.defaultWorkflowOptions; }
        lambda.source = lambda.source || runtime_types_1.LambdaSource.Custom; // This can be either Local or Custom; default to Custom
        return this.registerHardcodedWorkflow(name, [lambda], this.inputSchemasToWorkflows, options);
    };
    ClientRuntimeALv1.prototype.registerSimpleRemoteWorkflow = function (name, lambdaBefore, lambdaRemote, lambdaAfter, options) {
        if (options === void 0) { options = this.defaultWorkflowOptions; }
        var lambdas = [];
        if (lambdaBefore) {
            lambdaBefore.source = runtime_types_1.LambdaSource.Custom;
            lambdas.push(lambdaBefore);
        }
        lambdaRemote.source = lambdaRemote.func ? runtime_types_1.LambdaSource.Custom : runtime_types_1.LambdaSource.Remote; // If caller actually passed in a Custom lambda, treat it as such
        lambdas.push(lambdaRemote);
        if (lambdaAfter) {
            lambdaAfter.source = runtime_types_1.LambdaSource.Custom;
            lambdas.push(lambdaAfter);
        }
        return this.registerHardcodedWorkflow(name, lambdas, this.inputSchemasToWorkflows, options);
    };
    ClientRuntimeALv1.prototype.registerMultipleLambdasWorkflow = function (name, lambdas, options) {
        if (options === void 0) { options = this.defaultWorkflowOptions; }
        return this.registerHardcodedWorkflow(name, lambdas, this.inputSchemasToWorkflows, options);
    };
    ClientRuntimeALv1.prototype.registerReduceWorkflow = function (name, lambda, groupingKeyExtractor, bucketSize, options) {
        if (bucketSize === void 0) { bucketSize = 10; }
        if (options === void 0) { options = this.defaultWorkflowOptions; }
        this.reduceWorkflowsGroupingKeyExtractors.set(lambda.inputSchema, groupingKeyExtractor);
        this.resultCache.setBucketSize(lambda.inputSchema, bucketSize);
        lambda.source = lambda.source || runtime_types_1.LambdaSource.Custom; // Default to custom
        return this.registerHardcodedWorkflow(name, [lambda], this.inputSchemasToReduceWorkflows, options);
    };
    ClientRuntimeALv1.prototype.registerMultipleLambdasReduceWorkflow = function (name, lambdas, groupingKeyExtractor, bucketSize, options) {
        if (bucketSize === void 0) { bucketSize = 10; }
        if (options === void 0) { options = this.defaultWorkflowOptions; }
        this.reduceWorkflowsGroupingKeyExtractors.set(lambdas[0].inputSchema, groupingKeyExtractor);
        this.resultCache.setBucketSize(lambdas[0].inputSchema, bucketSize);
        return this.registerHardcodedWorkflow(name, lambdas, this.inputSchemasToReduceWorkflows, options);
    };
    ClientRuntimeALv1.prototype.submit = function (inputSchema, input, cv) {
        this.submitToWorkflows(inputSchema, input, cv, this.inputSchemasToWorkflows);
    };
    ClientRuntimeALv1.prototype.getGroupingKey = function (inputSchema, input, resultSchema) {
        var groupingKeyExtractor = this.reduceWorkflowsGroupingKeyExtractors.get(resultSchema);
        if (groupingKeyExtractor == undefined) {
            throw new Error('Reduce workflow does not have a grouping extractor');
        }
        return groupingKeyExtractor(input, inputSchema);
    };
    ClientRuntimeALv1.prototype.submitToWorkflows = function (inputSchema, input, cv, inputSchemasToWorkflows) {
        if (inputSchemasToWorkflows === void 0) { inputSchemasToWorkflows = this.inputSchemasToWorkflows; }
        if (!this.hostCallbacks) {
            return;
        }
        var cvParent;
        if (!cv) {
            cvParent = new logging_1.CorrelationVector();
        }
        else {
            cvParent = logging_1.CorrelationVector.fromString(cv);
        }
        this.handleTileRefresh(inputSchema, input, cvParent);
        var workflows = inputSchemasToWorkflows.get(inputSchema) || [];
        for (var _i = 0, workflows_1 = workflows; _i < workflows_1.length; _i++) {
            var workflow = workflows_1[_i];
            if (isTileRefreshEvent(inputSchema, input) && !workflow.triggerOnRefresh) {
                continue;
            }
            if (workflow.useCanaryTextTile && inputSchema === textTileSchema && !workflow.canaryTextTileEventSubmittedByDocSessionId.has(getTileDocSessionId(inputSchema, input))) {
                // A canary text tile is a fixed-content tile that is submitted before the actual tile content as a way
                // of ensuring that, under normal circumstances, the actual tile content has an opportunity to be batched
                // together with nearby tiles (when the workflow is in unrestricted mode), which improves the quality of
                // some workflow output (e.g. CLP).
                this.submitToWorkflow(textTileSchema, createCanaryTextTileEvent(input), cvParent, workflow, inputSchemasToWorkflows);
                workflow.canaryTextTileEventSubmittedByDocSessionId.add(getTileDocSessionId(inputSchema, input));
            }
            this.submitToWorkflow(inputSchema, input, cvParent, workflow, inputSchemasToWorkflows);
        }
    };
    ClientRuntimeALv1.prototype.submitToWorkflow = function (inputSchema, input, cvParent, workflow, inputSchemasToWorkflows) {
        var _this = this;
        var message = {
            messageType: schemas_1.MessageType.Input,
            correlationVector: cvParent.newChild(),
            payload: input,
            payloadSchema: exports.getTypeFromSchema(workflow.lambdas[0].inputSchema),
            clientMetadata: this.clientMetadata
        };
        var op = new logging_1.Operation({
            cv: message.correlationVector.toString(),
            operationName: 'ExecuteWorkflow',
            resourceId: workflow.name
        });
        op.start();
        workflow.scheduleExecution(input, function () {
            try {
                if (!message.payload || !message.payload.tile || !message.payload.tile.metadata || !message.payload.tile.metadata.tileId) {
                    _this.executeWorkflow(op, message, input, workflow, inputSchema, inputSchemasToWorkflows);
                }
                else {
                    // Use throttled execution for tile inputs
                    var tileId = message.payload.tile.metadata.tileId;
                    _this.throttling.execute(tileId, workflow, function () { return _this.executeWorkflow(op, message, input, workflow, inputSchema, inputSchemasToWorkflows); });
                }
            }
            catch (error) {
                op.success = false;
                op.resultSignature = 'ExecuteException';
                op.resultDescription = error ? error.message : '(no error)';
                logging_1.Log.error(0x2156184f /* tag_7v77p */, logging_1.LogCategory.CoreDefault, op.stop());
            }
        });
    };
    ClientRuntimeALv1.prototype.handleTileRefresh = function (inputSchema, input, cv) {
        var _this = this;
        if (!isTileRefreshEvent(inputSchema, input)) {
            return;
        }
        var docSessionId = this.tileRefreshByDocSessionIdEnabled ? getTileDocSessionId(inputSchema, input) : undefined;
        // Nothing to do if we've already seen a tile associated with this seq
        var seq = getTileRefreshSeq(inputSchema, input);
        if (this.tileRefreshByDocSessionIdEnabled) {
            var lastTileRefreshSeq = this.lastTileRefreshSeqByDocSessionId.get(docSessionId);
            if (lastTileRefreshSeq >= 0 && seq <= lastTileRefreshSeq) {
                return;
            }
        }
        else {
            if (seq <= this.lastTileRefreshSeq) {
                return;
            }
        }
        var op = new logging_1.Operation({
            cv: cv.toString(),
            operationName: 'TileRefresh',
            resultDescription: '',
            success: true
        });
        op.start();
        // We require tile refreshes to be associated with a docSessionId
        if (this.tileRefreshByDocSessionIdEnabled && !docSessionId) {
            op.success = false;
            op.resultDescription = 'NoDocSessionId';
            logging_1.Log.info(0x21561850 /* tag_7v77q */, logging_1.LogCategory.CoreDefault, op.stop());
            return;
        }
        // Clear caches for tile-refresh-aware reduce workflows
        this.inputSchemasToReduceWorkflows.forEach(function (workflows, reduceInputSchema) {
            if (workflows.some(function (x) { return x.triggerOnRefresh; })) {
                if (_this.tileRefreshByDocSessionIdEnabled) {
                    // Clear the result cache for this schema (at potentially both doc and tile level)
                    _this.resultCache.clear(reduceInputSchema, { primary: docSessionId });
                    _this.resultCache.clear(_this.getForcedDocLevelSchema(reduceInputSchema), { primary: docSessionId });
                    // Cancel any pending reduces that might emit stale results into the cache
                    _this.reduceTimerCache.clear(reduceInputSchema, docSessionId);
                }
                else {
                    // Clear the result caches for this schema (at potentially both doc and tile level)
                    _this.resultCache.clear(reduceInputSchema);
                    _this.resultCache.clear(_this.getForcedDocLevelSchema(reduceInputSchema));
                    // Cancel any pending reduces that might emit stale results into the cache
                    _this.reduceTimerCache.clear(reduceInputSchema);
                }
                if (workflows.some(function (x) { return !x.triggerOnRefresh; })) {
                    // Reaching this would be weird, which is why we're just using a short
                    // and cryptic string here to avoid bloating the bundle for a condition
                    // we'll likely never see (but we still want to know if it ever happens).
                    // This can be removed once we don't expect new ALv1 workflows.
                    op.resultDescription += 'X_'; // Unexpected
                }
                // Record all reduce input schemas that we cleared
                op.resultDescription += reduceInputSchema + ' ';
            }
        });
        // Force auth tokens to be refreshed (no simple way to do this just for tile-refresh-aware
        // workflows, so we do it across the board; should have no functional impact other than
        // causing remote lambdas to fetch new tokens next time they run)
        this.clearRemoteLambdaTokenCache();
        // Reset all workflow execution states (since we cleared all auth tokens)
        var allWorkflows = [];
        this.inputSchemasToWorkflows.forEach(function (workflows) { return allWorkflows.push.apply(allWorkflows, workflows); });
        this.inputSchemasToReduceWorkflows.forEach(function (workflows) { return allWorkflows.push.apply(allWorkflows, workflows); });
        for (var _i = 0, allWorkflows_1 = allWorkflows; _i < allWorkflows_1.length; _i++) {
            var workflow = allWorkflows_1[_i];
            if (this.tileRefreshByDocSessionIdEnabled) {
                workflow.onRefresh(docSessionId);
            }
            else {
                workflow.onRefresh();
            }
        }
        if (this.tileRefreshByDocSessionIdEnabled) {
            this.lastTileRefreshSeqByDocSessionId.set(docSessionId, seq);
        }
        else {
            this.lastTileRefreshSeq = seq;
        }
        logging_1.Log.info(0x21561851 /* tag_7v77r */, logging_1.LogCategory.CoreDefault, op.stop());
    };
    /**
     * Schedules workflow lambdas and finish step after all lambdas have completed
     */
    ClientRuntimeALv1.prototype.executeWorkflow = function (op, message, input, workflow, inputSchema, inputSchemasToWorkflows) {
        var _this = this;
        var docId = workflow.docIdExtractor ? workflow.docIdExtractor(message.payload) : undefined;
        var docSessionId = Workflow.trackingByDocSessionIdEnabled ? workflow.docSessionIdExtractor(input) : docId;
        var tileRefreshSeqForThisExecution = this.tileRefreshByDocSessionIdEnabled ? this.lastTileRefreshSeqByDocSessionId.get(docSessionId) : this.lastTileRefreshSeq;
        workflow.onStart(docSessionId);
        var finish = function (message) {
            // If this is a tile-refresh-aware workflow and a tile refresh occurred
            // since we began workflow execution, we'll want to ignore the results
            // (since we now only care about the new executions triggered by the refresh)
            var lastTileRefreshSeq = _this.tileRefreshByDocSessionIdEnabled ? _this.lastTileRefreshSeqByDocSessionId.get(docSessionId) : _this.lastTileRefreshSeq;
            if (workflow.triggerOnRefresh && lastTileRefreshSeq !== tileRefreshSeqForThisExecution) {
                op.success = true; // Not a failure
                op.resultSignature = 'TileRefreshIgnore';
                logging_1.Log.info(0x21561852 /* tag_7v77s */, logging_1.LogCategory.CoreDefault, op.stop());
                return;
            }
            var isNoOutputMessage = message.messageType == schemas_1.MessageType.Exception && message.payload.exceptionType == schemas_1.ExceptionType.NoOutput;
            var shouldProduceNullResult = isNoOutputMessage && workflow.canProduceNullResult;
            // Get workflow output information
            var outputSchema = shouldProduceNullResult ? workflow.lambdas[workflow.lambdas.length - 1].outputSchema : message.payloadSchema.schema.name;
            var output = shouldProduceNullResult ? null : message.payload;
            if (message.messageType === schemas_1.MessageType.Input || shouldProduceNullResult) {
                if (workflow.shouldSendResultsToHost) {
                    if (inputSchemasToWorkflows === _this.inputSchemasToReduceWorkflows) {
                        _this.hostCallbacks.onResult('Reduce.Input', input, outputSchema, output);
                    }
                    else {
                        _this.hostCallbacks.onResult(inputSchema, input, outputSchema, output);
                    }
                }
                op.success = true;
                op.resultSignature = isNoOutputMessage ? 'NoOutput' : 'ValidOutput';
            }
            else if (isNoOutputMessage) {
                op.success = true;
                op.resultSignature = 'NoOutput';
            }
            else {
                op.success = false;
                op.resultSignature = 'Exception';
                op.resultDescription = alv1_interfaces_1.getMessageExceptionDescription(message);
            }
            if (inputSchemasToWorkflows !== _this.inputSchemasToReduceWorkflows) {
                _this.updateResultCacheForReduceWorkflows(inputSchema, input, outputSchema, output, message.correlationVector.toString());
            }
            if (!message.moreResults) {
                op.stop();
                logging_1.Log.info(0x21561853 /* tag_7v77t */, logging_1.LogCategory.CoreDefault, op);
                workflow.onFinish(docSessionId, (message.payload && message.payload.exceptionType) ? alv1_interfaces_1.getMessageExceptionType(message) : undefined);
            }
        };
        workflow.preExecutionPromise.then(function () {
            var lambdaContext = {
                lookupTable: _this.lookupTableCache.get(workflow.name),
                docId: docId
            };
            // In reverse workflow order, build up the done() chain
            var nextStep = finish;
            for (var i = workflow.lambdas.length - 1; i >= 0; i--) {
                nextStep = _this.createLambdaExecutionStep(workflow.name, workflow.lambdas[i], lambdaContext, nextStep, finish);
            }
            // Start the workflow execution
            nextStep(message);
        });
    };
    ClientRuntimeALv1.prototype.getForcedDocLevelSchema = function (schema) {
        // There is special logic here to support the results of a single outputSchema to be stored
        // in the result cache both at the doc level AND at the tile level. Because the result cache
        // normally can only store a given outputSchema at either of those levels, we get around this
        // by synthesizing a dummy outputSchema name when inputSchema is 'docId'. Tile level results
        // for outputSchema, say, Baz are stored at 'Baz' and doc level results are stored at '~Baz'.
        // We recombine them in the reduce timer callback.
        return "~" + schema;
    };
    ClientRuntimeALv1.prototype.updateResultCacheForReduceWorkflows = function (inputSchema, input, outputSchema, output, cv) {
        var _this = this;
        var reduceWorkflows = this.inputSchemasToReduceWorkflows.get(outputSchema);
        if (reduceWorkflows) {
            var groupingKey_1;
            if (inputSchema === 'docId') {
                // Set the output as a doc-level result using the groupingKeyExtractor defined for the reduce
                // workflow with the modified outputSchema name so it doesn't replace the tile-level results...
                groupingKey_1 = this.getGroupingKey(inputSchema, input, outputSchema);
                this.resultCache.setResult(this.getForcedDocLevelSchema(outputSchema), groupingKey_1, output);
                // ...then set the secondary key to an arbitrary value to force the result cache to return
                // tile-level results in the reduce timer callback (if this happens to be the only or last
                // call to this method for this doc). This rather hackily relies on the fact that getResults
                // only checks for the existence of the secondary key and doesn't care about its value.
                groupingKey_1.secondary = '*';
            }
            else {
                groupingKey_1 = this.getGroupingKey(inputSchema, input, outputSchema);
                // Remove results from cache if this is a TileDeleted event
                if (isTileDeletedEvent(inputSchema, input)
                    && groupingKey_1.primary != undefined
                    && groupingKey_1.secondary != undefined) {
                    this.resultCache.clear(undefined /*resultSchema*/, groupingKey_1);
                }
                else {
                    this.resultCache.setResult(outputSchema, groupingKey_1, output);
                }
            }
            // If any workflow has requested it, defer reduce execution while any workflow that is upstream of the
            // reduce workflow(s) still has pending executions for this doc
            var anyWorkflowsDeferReduceUntilIdle_1 = reduceWorkflows.some(function (x) { return x.deferReduceUntilIdle; });
            var upstreamWorkflows_1 = [];
            this.inputSchemasToWorkflows.forEach(function (workflows) { return upstreamWorkflows_1.push.apply(upstreamWorkflows_1, workflows.filter(function (x) { return x.getOutputSchema() === outputSchema; })); });
            var shouldDefer = function () {
                return anyWorkflowsDeferReduceUntilIdle_1 && upstreamWorkflows_1.some(function (x) { return x.executionCountByDocSessionId.get(groupingKey_1.primary) > 0; });
            };
            // But only up to the max deferral time specified by any of the workflows
            var maxDeferMs = reduceWorkflows.map(function (x) { return x.deferReduceUntilIdleMaxDelayMs || 0; }).reduce(function (prev, curr) { return Math.max(prev, curr); });
            this.reduceTimerCache.setReduceTimer(outputSchema, groupingKey_1.primary, function () {
                var results = _this.resultCache.getResults(outputSchema, groupingKey_1);
                // Recombine tile-level and doc-level results (if any) for the same outputSchema name
                results.push.apply(results, _this.resultCache.getResults(_this.getForcedDocLevelSchema(outputSchema), { primary: groupingKey_1.primary }));
                if (Array.isArray(results)) {
                    var reduceInput = { id: groupingKey_1.primary, values: results, isReduceInput: true };
                    _this.submitToWorkflows(outputSchema, reduceInput, cv, _this.inputSchemasToReduceWorkflows);
                }
                else {
                    logging_1.Log.error(0x21561854 /* tag_7v77u */, logging_1.LogCategory.CoreDefault, "Cached results have unexpected type \"" + typeof results + "\"");
                }
            }, 500 /*reduceTimeoutMs*/, shouldDefer, maxDeferMs);
        }
    };
    ClientRuntimeALv1.prototype.isFeatureEnabled = function (featureName, defaultValue, scope) {
        if (defaultValue === void 0) { defaultValue = false; }
        if (scope === void 0) { scope = 'None'; }
        return this.hostCallbacks && this.hostCallbacks.isFeatureEnabled
            ? this.hostCallbacks.isFeatureEnabled('Microsoft.Office.AugLoop.' + featureName, scope)
                .catch(function () { return Promise.resolve(defaultValue); })
            : Promise.resolve(defaultValue);
    };
    ClientRuntimeALv1.prototype.areLicenseFeaturesEnabled = function (licenseFeatures) {
        return this.hostCallbacks && this.hostCallbacks.areLicenseFeaturesEnabled
            ? this.hostCallbacks.areLicenseFeaturesEnabled(licenseFeatures)
                .catch(function () { return Promise.resolve(false); })
            : Promise.resolve(false);
    };
    ClientRuntimeALv1.prototype.isWorkflowEnabled = function (name, lambdas, licenseFeatures, enabledByDefault, op) {
        var _this = this;
        var isRemoteWorkflow = lambdas.some(function (lambda) { return lambda.source === runtime_types_1.LambdaSource.Remote || lambda.source === runtime_types_1.LambdaSource.BatchedRemote; });
        if (isRemoteWorkflow) {
            if (!this.serviceUrl) {
                op.resultDescription = 'Disabled because no service URL available for remote workflow';
                return Promise.resolve(false);
            }
            // check if we have any non-allow-listed remote lambdas in private mode
            if (this.clientMetadata && this.clientMetadata.privateMode) {
                if (lambdas.some(function (lambda) { return (lambda.source === runtime_types_1.LambdaSource.Remote || lambda.source === runtime_types_1.LambdaSource.BatchedRemote) && !lambda.canRunInPrivateMode; })) {
                    op.resultDescription = 'Disabled because we are running in private mode';
                    return Promise.resolve(false);
                }
            }
        }
        if (!this.clientMetadata || (this.clientMetadata.appPlatform !== 'Mac' && this.clientMetadata.appPlatform !== 'Win32')) {
            // Only Win32/Mac currently need an explicit enabled by default
            enabledByDefault = true;
            op.resultDescription = 'Enabled by default due to platform name';
        }
        var isWorkflowEnabled;
        if (enabledByDefault) {
            isWorkflowEnabled = Promise.resolve(true);
        }
        else {
            isWorkflowEnabled = this.isFeatureEnabled('WorkflowEnabled.' + name);
        }
        return isWorkflowEnabled.then(function (isEnabled) {
            if (isEnabled) {
                return _this.isFeatureEnabled('WorkflowDisabled.' + name).then(function (isDisabled) {
                    if (isDisabled) {
                        op.resultDescription = 'Disabled because explicitly disabled';
                        return false;
                    }
                    if (licenseFeatures) {
                        return _this.areLicenseFeaturesEnabled(licenseFeatures).then(function (isEnabled) {
                            if (!isEnabled) {
                                op.resultDescription = 'Disabled because license check failed';
                            }
                            return isEnabled;
                        });
                    }
                    return true;
                });
            }
            else {
                op.resultDescription = 'Disabled because not explicitly enabled';
                return false;
            }
        });
    };
    ClientRuntimeALv1.prototype.registerHardcodedWorkflow = function (name, lambdas, inputSchemasToWorkflows, options) {
        var _this = this;
        if (inputSchemasToWorkflows === void 0) { inputSchemasToWorkflows = this.inputSchemasToWorkflows; }
        if (!name || name.length > 40) {
            throw new Error('Workflow name has invalid length');
        }
        if (new RegExp(/^[A-Z][a-zA-Z0-9_]+$/).test(name) === false) {
            throw new Error('Workflow name has invalid format');
        }
        inputSchemasToWorkflows.forEach(function (workflows) {
            if (workflows.some(function (workflow) { return workflow.name === name; })) {
                throw new Error('Workflow name already registered.');
            }
        });
        var op = new logging_1.Operation({
            operationName: 'WorkflowRegistration',
            resourceId: name,
            success: true
        });
        op.setClientMetadata(this.clientMetadata);
        op.start();
        return this.isWorkflowEnabled(name, lambdas, options.licenseFeatures, options.enabledByDefault, op).then(function (isEnabled) {
            op.resultSignature = isEnabled ? 'Enabled' : 'Disabled';
            op.stop();
            logging_1.Log.info(0x21561855 /* tag_7v77v */, logging_1.LogCategory.CoreDefault, op);
            if (isEnabled) {
                var inputSchema_1 = lambdas[0].inputSchema;
                var workflows = inputSchemasToWorkflows.get(inputSchema_1);
                if (!workflows) {
                    workflows = [];
                    inputSchemasToWorkflows.set(inputSchema_1, workflows);
                }
                var preExecutionPromise = Promise.resolve();
                if (options.lookupTableLambda) {
                    preExecutionPromise = new Promise(function (resolve, _reject) {
                        var cv = new logging_1.CorrelationVector();
                        var message = {
                            messageType: schemas_1.MessageType.Input,
                            correlationVector: cv,
                            payloadSchema: exports.getTypeFromSchema(options.lookupTableLambda.inputSchema),
                            clientMetadata: _this.clientMetadata,
                            payload: {}
                        };
                        var lambdaCallback = function (message) {
                            if (message.messageType === schemas_1.MessageType.Input && message.payload) {
                                _this.lookupTableCache.set(name, message.payload);
                            }
                            resolve();
                        };
                        var nextStep = _this.createLambdaExecutionStep('' /* workflowName */, options.lookupTableLambda, {} /* lambdaContext */, lambdaCallback, lambdaCallback);
                        nextStep(message);
                    });
                }
                var workflow = new Workflow();
                workflow.name = name;
                workflow.lambdas = lambdas;
                workflow.canProduceNullResult = options.canProduceNullResult;
                workflow.shouldSendResultsToHost = options.shouldSendResultsToHost;
                workflow.triggerOnRefresh = options.triggerOnRefresh;
                workflow.throttleSettings = options.throttleSettings || _this.defaultWorkflowOptions.throttleSettings;
                workflow.docIdExtractor = options.docIdExtractor;
                workflow.docSessionIdExtractor = function (input) {
                    if (input.isReduceInput) {
                        return input.id;
                    }
                    return getTileDocSessionId(inputSchema_1, input);
                };
                workflow.deferReduceUntilIdle = options.deferReduceUntilIdle;
                workflow.deferReduceUntilIdleMaxDelayMs = options.deferReduceUntilIdleMaxDelayMs;
                workflow.useCanaryTextTile = options.useCanaryTextTile;
                workflow.preExecutionPromise = preExecutionPromise;
                workflows.push(workflow);
            }
        });
    };
    // ExecuteLambda result signatures:
    // 'Exception' = lambda func resulted in exception
    // 'NoOutput'  = lambda func resulted in null output
    // 'Error'     = client runtime has an error
    ClientRuntimeALv1.prototype.logOperation = function (op, success, resultSignature, resultDescription) {
        op.stop();
        op.success = success;
        op.resultSignature = resultSignature;
        op.resultDescription = resultDescription;
        logging_1.Log.info(0x21561856 /* tag_7v77w */, logging_1.LogCategory.CoreDefault, op);
    };
    ClientRuntimeALv1.prototype.handleLambdaError = function (exception, message, op, exceptionType, finish) {
        // Handle Exception outputs
        if (exception.exceptionType != undefined) {
            alv1_interfaces_1.setMessageException(message, exception);
        }
        else if (exception instanceof Error) {
            alv1_interfaces_1.setMessageException(message, {
                exceptionType: exceptionType,
                message: exception.message
            });
        }
        else {
            alv1_interfaces_1.setMessageException(message, {
                exceptionType: schemas_1.ExceptionType.Unknown,
                message: exception ? exception.toString() : undefined
            });
        }
        this.logOperation(op, false, 'Exception', alv1_interfaces_1.getMessageExceptionDescription(message));
        finish(message);
    };
    ClientRuntimeALv1.prototype.handleLambdaOutput = function (output, message, op, outputSchema, nextStep, finish) {
        if (output && output.exceptionType !== schemas_1.ExceptionType.NoOutput) {
            if (output.exceptionType != undefined) {
                this.handleLambdaError(output, message, op, output.exceptionType, finish);
            }
            else if (output instanceof Error) {
                this.handleLambdaError(output, message, op, schemas_1.ExceptionType.LambdaErrorCallback, finish);
            }
            else {
                message.payload = output;
                message.payloadSchema = exports.getTypeFromSchema(outputSchema);
                this.logOperation(op, true);
                nextStep(message);
            }
        }
        else {
            alv1_interfaces_1.setMessageException(message, {
                exceptionType: schemas_1.ExceptionType.NoOutput
            });
            this.logOperation(op, true, 'NoOutput'); // Returning no output is not an error
            finish(message);
        }
    };
    ClientRuntimeALv1.prototype.executeCustomLambdaStep = function (message, op, customLambda, context, nextStep, finish) {
        var _this = this;
        if (customLambda.func == null) {
            alv1_interfaces_1.setMessageException(message, {
                exceptionType: schemas_1.ExceptionType.LambdaThrow,
                message: 'No lambda function set'
            });
            this.logOperation(op, false, 'Error', alv1_interfaces_1.getMessageExceptionDescription(message));
            finish(message);
        }
        else {
            var done = function (output) {
                _this.handleLambdaOutput(output, message, op, customLambda.outputSchema, nextStep, finish);
            };
            var finishWorkflow = function (output, outputSchema) {
                _this.handleLambdaOutput(output, message, op, outputSchema, finish, finish);
            };
            try {
                customLambda.func(message.payload, customLambda.config, context, done, finishWorkflow);
            }
            catch (exception) {
                this.handleLambdaError(exception, message, op, schemas_1.ExceptionType.LambdaThrow, finish);
            }
        }
    };
    ClientRuntimeALv1.prototype.executeLocalLambdaStep = function (message, op, localLambda, nextStep, finish) {
        var _this = this;
        if (this.hostCallbacks.executeLocalLambda == undefined) {
            alv1_interfaces_1.setMessageException(message, {
                exceptionType: schemas_1.ExceptionType.LambdaThrow,
                message: 'No local lambda host callback set'
            });
            this.logOperation(op, false, 'Error', alv1_interfaces_1.getMessageExceptionDescription(message));
            finish(message);
        }
        else {
            this.hostCallbacks.executeLocalLambda(localLambda.inputSchema, message.payload, localLambda.outputSchema)
                .then(function (output) {
                _this.handleLambdaOutput(output, message, op, localLambda.outputSchema, nextStep, finish);
            })
                .catch(function (err) {
                _this.handleLambdaError(err, message, op, schemas_1.ExceptionType.LambdaThrow, finish);
            });
        }
    };
    ClientRuntimeALv1.prototype.executeRemoteLambdaStep = function (message, op, remoteLambda, context, nextStep, finish) {
        var _this = this;
        if (this.serviceUrl) {
            op.resourceId += "." + this.serviceProtocol;
            var done = function (err, output) {
                if (err) {
                    _this.handleLambdaError(err, message, op, err.exceptionType || schemas_1.ExceptionType.LambdaErrorCallback, finish);
                }
                else {
                    _this.handleLambdaOutput(output, message, op, remoteLambda.outputSchema, nextStep, finish);
                }
            };
            context.authTickets = remoteLambda.authTickets;
            if (remoteLambda.source === runtime_types_1.LambdaSource.Remote) {
                this.executeRemoteLambda(this.serviceUrl, message, exports.getTypeFromSchema(remoteLambda.inputSchema), exports.getTypeFromSchema(remoteLambda.outputSchema), message.correlationVector, this.clientMetadata, this.hostCallbacks, context, done);
            }
            else { // LambdaSource.BatchedRemote
                if (!this.batchedRemoteLambdaManager) {
                    this.batchedRemoteLambdaManager = new runtime_client_1.BatchManager(function (input, batch, callback) {
                        var _a = batch.context, remoteLambda = _a.remoteLambda, lambdaContext = _a.lambdaContext;
                        _this.executeRemoteLambda(_this.serviceUrl, {
                            messageType: schemas_1.MessageType.Input,
                            correlationVector: { id: batch.cv },
                            payload: input,
                            payloadSchema: exports.getTypeFromSchema(remoteLambda.inputSchema),
                            clientMetadata: _this.clientMetadata
                        }, exports.getTypeFromSchema(remoteLambda.remoteInputSchema), exports.getTypeFromSchema(remoteLambda.remoteOutputSchema), { id: batch.cv }, _this.clientMetadata, _this.hostCallbacks, lambdaContext, callback);
                    }, function (summarySchemaName, summary, context) {
                        // Summary outputs are attached as doc-level entries in the result cache
                        var lambdaContext = context.lambdaContext;
                        _this.updateResultCacheForReduceWorkflows('docId' /*inputSchema*/, lambdaContext.docId, summarySchemaName, summary);
                    });
                }
                // Get the normalized batching config
                var batchOptions = remoteLambda.batchOptions;
                var normalizedConfig = this.normalizeBatchOptions(batchOptions);
                // Add the remote lambda name to the grouping key
                var groupingKeyExtractor_1 = normalizedConfig.groupingKeyExtractor;
                normalizedConfig.groupingKeyExtractor = function (input) { return remoteLambda.name + "-" + groupingKeyExtractor_1(input); };
                // Add the inputs to the next batch
                var batchedRemoteLambdaContext = {
                    name: remoteLambda.name,
                    remoteLambda: remoteLambda,
                    lambdaContext: context
                };
                this.batchedRemoteLambdaManager.addBatchItem(message.payload, normalizedConfig, batchedRemoteLambdaContext, message.correlationVector.id.length > 127
                    ? message.correlationVector.id.substring(0, 127) + '!'
                    : message.correlationVector.id, undefined, done);
            }
        }
        else {
            alv1_interfaces_1.setMessageException(message, {
                exceptionType: schemas_1.ExceptionType.LambdaThrow,
                message: 'No URL for remote lambda'
            });
            this.logOperation(op, false, 'Error', alv1_interfaces_1.getMessageExceptionDescription(message));
            finish(message);
        }
    };
    ClientRuntimeALv1.prototype.createLambdaExecutionStep = function (workflowName, lambda, context, nextStep, finish) {
        var _this = this;
        return function (message) {
            var op = new logging_1.Operation({
                cv: message.correlationVector.toString(),
                operationName: 'ExecuteLambda',
                resourceId: lambda.name,
                dimension0: workflowName
            });
            op.start();
            if (lambda.source === runtime_types_1.LambdaSource.Custom) {
                _this.executeCustomLambdaStep(message, op, lambda, context, nextStep, finish);
            }
            else if (lambda.source === runtime_types_1.LambdaSource.Local) {
                _this.executeLocalLambdaStep(message, op, lambda, nextStep, finish);
            }
            else if (lambda.source === runtime_types_1.LambdaSource.Remote || lambda.source === runtime_types_1.LambdaSource.BatchedRemote) {
                _this.executeRemoteLambdaStep(message, op, lambda, context, nextStep, finish);
            }
            else {
                alv1_interfaces_1.setMessageException(message, {
                    exceptionType: schemas_1.ExceptionType.LambdaThrow,
                    message: 'Unknown/No lambda location set'
                });
                _this.logOperation(op, false, 'Error', alv1_interfaces_1.getMessageExceptionDescription(message));
                finish(message);
            }
        };
    };
    ClientRuntimeALv1.prototype.normalizeBatchOptions = function (batchConfig) {
        if (!batchConfig) {
            throw new Error('Expected batchConfig');
        }
        var newConfig = __assign({}, batchConfig);
        if (!batchConfig.estimateSize) {
            newConfig.estimateSize = runtime_client_1.estimateSize;
        }
        return newConfig;
    };
    return ClientRuntimeALv1;
}());
exports.ClientRuntimeALv1 = ClientRuntimeALv1;
exports.runtimeALv1 = new ClientRuntimeALv1();
//# sourceMappingURL=runtime-client.js.map